<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.createProfessor')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">

                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.employee.createProfessor')}}</div>
                        <button class="btn btn-primary float-right"
                            @click="saveProfessor()">{{$t('button.save')}}</button>
                    </div>

                    <div class="card-body">
                        <b-tabs content-class="mt-3">
                            <b-tab :title="$t('form.employee.tabPersonal')" active>
                                <div class="row">
                                    <div class="col-md-3">
                                     	<div class="form-group">
                                            <h3>{{$t('form.employee.photo')}}</h3>
                                            <input type="file"  ref="profile_image"  style="display:none" @input="showSelectedImage" accept="image/*">
                                            <img  :src="image" @click="$refs.profile_image.click()"
                                            class="img-responsive" style="cursor:pointer; max-width:200px; max-height:200px">
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="Title:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professor.Title"
                                                :reduce="titles => titles">
                                            </v-select>
                                            <span id="errId2" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="FirstName:">
                                                {{$t('form.employee.firstName')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" id="FirstNameField" class="form-control"
                                                :class="{ 'is-invalid': $v.professor.FirstName.$error }"
                                                v-model.trim="$v.professor.FirstName.$model">
                                            <div class="invalid-feedback" v-if="!$v.professor.FirstName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professor.FirstName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.FirstName.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="LastName">
                                                {{$t('form.employee.lastName')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" id="LastNameField" class="form-control"
                                                v-model.trim="$v.professor.LastName.$model"
                                                :class="{ 'is-invalid': $v.professor.LastName.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.LastName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professor.LastName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.LastName.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="BirthDate:">
                                                {{$t('form.employee.birthDate')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input id="BirthDate" name="BirthDate" v-model="professor.BirthDate"
                                                type="date" class="form-control"
                                                :class="{ 'is-invalid': $v.professor.BirthDate.$error }"
                                                v-model.trim="$v.professor.BirthDate.$model">
                                            <div class="invalid-feedback" v-if="!$v.professor.BirthDate.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="BirthPlace:">
                                                {{$t('form.employee.birthPlace')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="BirthPlaceField"
                                                v-model="professor.BirthPlace" class="form-control"
                                                :class="{'is-invalid': $v.professor.BirthPlace.$error }">

                                            <div class="invalid-feedback" v-if="!$v.professor.BirthPlace.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.BirthPlace.$params.maxLength.max})}}
                                            </div>

                                        </div>

                                        <div class="form-group">
                                            <label for="BirthCountry">{{$t('form.employee.birthCountry')}}</label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model="professor.BirthCountry"
                                                :reduce="countries => countries.printable_name">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="Department">{{$t('form.employee.department')}}</label>
                                            <v-select :options="departments" v-model="professor.Department"
                                                :reduce="departments => departments">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="Position">{{$t('form.employee.position')}}</label>
                                            <v-select :options="positions" v-model="professor.Position"
                                                :reduce="positions => positions">
                                            </v-select>
                                        </div>

                                        <div class="form-group">
                                            <label for="StreetAddress">
                                                {{$t('form.employee.streetAddress')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.StreetAddress.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.StreetAddress.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.StreetAddress.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{$t('form.employee.city')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="CityField" v-model.trim="$v.professor.City.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.City.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.City.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.City.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.City.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Zip:">
                                                {{$t('form.employee.zip')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.Zip.$model"
                                                class="form-control" :class="{ 'is-invalid': $v.professor.Zip.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.Zip.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.Zip.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Zip.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Country">{{$t('form.employee.country')}} <span
                                                    class="text-danger">*</span> </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="$v.professor.Country.$model"
                                                :reduce="countries => countries.printable_name"
                                                class="ProfessorCountry">
                                            </v-select>

                                            <div class="invalid-feedback custom-validate"
                                                v-if="invalidProfessorCountry">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Phone:">
                                                {{$t('form.employee.phone')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.Phone.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.Phone.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.Phone.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.Phone.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Phone.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Mobile:">
                                                {{$t('form.employee.mobile')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professor.Mobile.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.Mobile.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.Mobile.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.Mobile.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professor.Mobile.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Fax">{{$t('form.employee.fax')}}</label>

                                            <input id="Fax" name="Fax" v-model="professor.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId16">
                                            <span id="errId16" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label>
                                                {{$t('form.employee.email')}}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input type="email" v-model.trim="$v.professor.Email.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professor.Email.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professor.Email.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professor.Email.email">
                                                {{$t('form.validation.validEmail')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="Email2:">{{$t('form.employee.email2')}}</label>
                                            <input id="Email2:" name="Email2" v-model="professor.Email2" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId18">
                                            <span id="errId18" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="Email3:">{{$t('form.employee.email3')}}</label>
                                            <input id="Email3:" name="Email3" v-model="professor.Email3" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId19">
                                            <span id="errId19" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="WebAddress">{{$t('form.employee.webAddress')}}</label>
                                            <input id="WebAddress" name="WebAddress" v-model="professor.WebAddress"
                                                type="text" class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId20">
                                            <span id="errId20" class="error"></span>
                                        </div>

                                        <div class="form-group">
                                            <label for="Notes:">{{$t('form.employee.notes')}}</label>
                                            <textarea id="Notes:" name="Notes" v-model="professor.Notes" rows="5"
                                                class="form-control" data-role="textarea"
                                                data-parsley-errors-container="#errId21"></textarea>
                                            <span id="errId21" class="error"></span>
                                        </div>
                                    </div>

                                    <div class="col-3">
                                          <div class="shadow mb-4 p-3">
                                            <h6>
                                                <u>
                                                    <b>{{$t('form.employee.mailAddress')}}</b>
                                                </u>
                                            </h6>
                                            <div class="form-group">
                                                <label>
                                                    <input type="radio" v-model="professor.MailAddress" value="1">
                                                    {{$t('form.employee.mailAddressOption1')}}
                                                </label>
                                            </div>
                                            <div class="form-group">
                                                <label>
                                                    <input type="radio" v-model="professor.MailAddress" value="2">
                                                    {{$t('form.employee.mailAddressOption2')}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabBusiness')">
                                <div class="row">
                                    <div class="col-sm-8"  v-if="parseInt(professor.MailAddress) === 2">
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{$t('form.employee.companyName')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input id="CompanyName" type="text"
                                                v-model.trim="$v.professorBusiness.CompanyName.$model"
                                                name="CompanyName" class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.CompanyName.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.CompanyName.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.CompanyName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.CompanyName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{$t('form.employee.department')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="BusinessDepartment"
                                                v-model.trim="$v.professorBusiness.Department.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Department.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Department.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Department.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Department.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{$t('form.employee.position')}}
                                                <span class="req text-danger">*</span>
                                            </label>

                                            <input id="BusinessPosition:" name="BusinessPosition"
                                                v-model.trim="$v.professorBusiness.Position.$model" class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Position.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Position.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.Position.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Position.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{$t('form.employee.streetAddress')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.StreetAddress.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.StreetAddress.$error }">
                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.StreetAddress.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{$t('form.employee.city')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" id="City" v-model.trim="$v.professorBusiness.City.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.City.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.City.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.City.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.City.$params.maxLength.max})}}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{$t('form.employee.zip')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Zip.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Zip.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Zip.required">
                                                {{$t('form.validation.required')}}</div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Zip.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Zip.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{$t('form.employee.country')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="$v.professorBusiness.Country.$model"
                                                :reduce="countries => countries.printable_name"
                                                class="BussinessCountry">
                                            </v-select>

                                            <div class="invalid-feedback custom-validate"
                                                v-if="invalidBussinessCountry">
                                                {{$t('form.validation.required')}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{$t('form.employee.phone')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Phone.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Phone.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Phone.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Phone.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Phone.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{$t('form.employee.mobile')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="text" v-model.trim="$v.professorBusiness.Mobile.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Mobile.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Mobile.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Mobile.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.Mobile.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{$t('form.employee.fax')}}</label>

                                            <input id="Fax:" name="Fax" v-model="professorBusiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31">
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{$t('form.employee.email')}}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input type="email" v-model.trim="$v.professorBusiness.Email.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.Email.$error }">
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Email.required">
                                                {{$t('form.validation.required')}}
                                            </div>
                                            <div class="invalid-feedback" v-if="!$v.professorBusiness.Email.email">
                                                {{$t('form.validation.validEmail')}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{$t('form.employee.webAddress')}}
                                            </label>

                                            <input id="BussinessWebAddress:" name="BussinessWebAddress"
                                                v-model="professorBusiness.WebAddress" type="text" class="form-control"
                                                data-role="text" data-parsley-errors-container="#errId33">
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{$t('form.employee.contactPerson')}}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professorBusiness.ContactPersonTitle"
                                                :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{$t('form.employee.firstName')}}
                                            </label>

                                            <input type="text" id="ContactPersonFirstNameField"
                                                v-model.trim="$v.professorBusiness.ContactPersonFirstName.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonFirstName.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonFirstName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonFirstName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{$t('form.employee.lastName')}}
                                            </label>

                                            <input type="text" id="ContactPersonLastNameField"
                                                v-model.trim="$v.professorBusiness.ContactPersonLastName.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonLastName.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonLastName.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonLastName.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{$t('form.employee.department')}}
                                            </label>

                                            <input type="text" id="ContactPersonDepartment"
                                                v-model.trim="$v.professorBusiness.ContactPersonDepartment.$model"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.professorBusiness.ContactPersonDepartment.$error }">

                                            <div class="invalid-feedback"
                                                v-if="!$v.professorBusiness.ContactPersonDepartment.maxLength">
                                                {{$t('form.validation.maxLength', {num: $v.professorBusiness.ContactPersonDepartment.$params.maxLength.max})}}
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-sm-8"  v-else>
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{$t('form.employee.companyName')}}
                                            </label>
                                            <input id="CompanyName" type="text"
                                                v-model.trim="professorBusiness.CompanyName"
                                                name="CompanyName" class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{$t('form.employee.department')}}
                                            </label>
                                            <input type="text" id="BusinessDepartment"
                                                v-model.trim="professorBusiness.Department"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{$t('form.employee.position')}}
                                            </label>

                                            <input id="BusinessPosition:" name="BusinessPosition"
                                                v-model.trim="professorBusiness.Position" class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{$t('form.employee.streetAddress')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.StreetAddress"
                                                class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{$t('form.employee.city')}}
                                            </label>
                                            <input type="text" id="City" v-model.trim="professorBusiness.City"
                                                class="form-control">
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{$t('form.employee.zip')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Zip"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{$t('form.employee.country')}}
                                            </label>
                                            <v-select label="printable_name" :options="countries"
                                                v-model.trim="professorBusiness.Country"
                                                :reduce="countries => countries.printable_name"
                                                class="BussinessCountry">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{$t('form.employee.phone')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Phone"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{$t('form.employee.mobile')}}
                                            </label>
                                            <input type="text" v-model.trim="professorBusiness.Mobile"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{$t('form.employee.fax')}}</label>

                                            <input id="Fax:" name="Fax" v-model="professorBusiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31">
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{$t('form.employee.email')}}
                                            </label>
                                            <input type="email" v-model.trim="professorBusiness.Email"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{$t('form.employee.webAddress')}}
                                            </label>

                                            <input id="BussinessWebAddress:" name="BussinessWebAddress"
                                                v-model="professorBusiness.WebAddress" type="text" class="form-control"
                                                data-role="text" data-parsley-errors-container="#errId33">
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{$t('form.employee.contactPerson')}}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{$t('form.employee.title')}}</label>
                                            <v-select :options="titles" v-model="professorBusiness.ContactPersonTitle"
                                                :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{$t('form.employee.firstName')}}
                                            </label>

                                            <input type="text" id="ContactPersonFirstNameField"
                                                v-model.trim="professorBusiness.ContactPersonFirstName"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{$t('form.employee.lastName')}}
                                            </label>

                                            <input type="text" id="ContactPersonLastNameField"
                                                v-model.trim="professorBusiness.ContactPersonLastName"
                                                class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{$t('form.employee.department')}}
                                            </label>

                                            <input type="text" id="ContactPersonDepartment"
                                                v-model.trim="professorBusiness.ContactPersonDepartment"
                                                class="form-control">
                                        </div>
                                    </div>


                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class for="Notes:">{{$t('form.employee.notes')}}</label>
                                            <textarea id="Notes:" name="Notes" v-model="professorBusiness.Notes"
                                                rows="15" class="form-control" data-role="textarea"
                                                data-parsley-errors-container="#errId39"></textarea>
                                            <span id="errId39" class="error"></span>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabRemarks')">
                                <div class="form-group">
                                    <label class for="Remarks:">{{$t('form.employee.remarks')}}</label>
                                    <textarea id="Remarks:" name="Remarks" v-model="professor.Remarks" rows="15"
                                        class="form-control" data-role="textarea"
                                        data-parsley-errors-container="#errId40"></textarea>
                                    <span id="errId40" class="error"></span>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabCourses')">
                                <div>
                                    <table class="table table-borderd">
                                        <thead>
                                            <th style="min-width:200px">{{$t('form.employee.program')}}<span
                                                    v-if="lectures.length > 0" class="text-danger">*</span>
                                            </th>
                                            <th style="min-width:200px">{{$t('form.employee.course')}}<span
                                                    v-if="lectures.length > 0" class="text-danger">*</span>
                                            </th>
                                            <th>{{$t('form.employee.academicYear')}}<span v-if="lectures.length > 0"
                                                    class="text-danger">*</span></th>
                                            <th>{{$t('form.employee.term')}}<span v-if="lectures.length > 0"
                                                    class="text-danger">*</span>
                                            </th>
                                            <th class="text-right">
                                                <b-button @click="addLecture()" :title="$t('button.new')">
                                                    <i class="fas fa-plus-circle"></i></b-button>
                                            </th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(lecture, index) in lectures" :key="index">
                                                <td>
                                                    <v-select @input="selectProgram(index)" label="FullTitle"
                                                        :options="programs" v-model="lecture.ProgramID"
                                                        :reduce="program => program.ID">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select label="FullTitle" :options="courses[index]"
                                                        v-model="lecture.CourseID" :reduce="course => course.ID">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <select v-model="lecture.AcademicYear" class="form-control">
                                                        <option v-for="(academicYear , index) in academicYearList"
                                                            :key="index" :value="academicYear">
                                                            {{academicYear}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input type="number" class="form-control" v-model="lecture.Term">
                                                </td>
                                                <td class="text-right">
                                                    <a class="btn btn-danger text-white btn-sm"
                                                        @click="removeLecture(index)">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.employee.tabContracts')">
                                <div class="row">
                                    <div class="col-md-8">
                                        <!-- <br> -->
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <tr>
                                                    <th>{{$t('form.employee.file')}}</th>
                                                    <th>{{$t('form.student.UploadTimestamp')}}</th>
                                                    <th>{{$t('form.employee.fileName')}}</th>
                                                    <th>{{$t('form.employee.fileDescription')}}</th>
                                                    <th></th>
                                                </tr>
                                                <tbody>
                                                    <tr v-for="(file , index) in contracts" v-bind:key="index">
                                                        
                                                        <td>
                                                            <i class="fa fa-file" aria-hidden="true"></i>
                                                        </td>
                                                       <td class="text-center">
                                                            {{file.UploadTimestamp}}
                                                        </td>
                                                        <td>{{file.Name}}

                                                               | <a href="#" @click="downloadContract(file)" class="ml-2"> {{$t('button.view')}}</a>

                                                        </td>
                                                        <td>
                                                            <input type="text" class="form-control"
                                                                v-model="contracts[index].Description">
                                                        </td>
                                                        <td>
                                                            <span style="color:red;cursor:pointer"
                                                                @click="removeContract(index,file)">
                                                                <i class="fa fa-times"></i>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="control-label"
                                                for="StatusID:">{{$t('form.employee.fileAttach')}}</label>

                                            <vue-dropzone ref="myVueDropzone" id="dropzone2" :options="contractDropzone"
                                                @vdropzone-success="contractUploaded"
                                                @vdropzone-error="uploadFileError"
                                                @vdropzone-processing="isLoading=true">
                                            </vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAttachment')">
                                <div class="row">
                                    <div class="col-md-8">
                                        <!-- <br> -->
                                        <div class="table-responsive p-0">
                                            <table class="table table-bordered">
                                                <tr>
                                                    <th>{{$t('form.student.file')}}</th>
                                                    <th>{{$t('form.student.UploadTimestamp')}}</th>
                                                    <th>{{$t('form.student.fileName')}}</th>
                                                    <th>{{$t('form.student.fileDescription')}}</th>
                                                </tr>
                                                <tbody>
                                                    <tr v-for="(file , index) in attachments" :key="index">
                                                        <td class="text-center">
                                                            <i class="fa fa-file" aria-hidden="true"></i>
                                                        </td>
                                                        <td class="text-center">
                                                            {{file.UploadTimestamp}}
                                                        </td>
                                                        <td>
                                                            {{file.Name}}

                                                              | <a href="#" @click.prevent="downloadAttachment(file)" class="ml-2"> {{$t('button.view')}}</a>
                                                        </td>
                                                        <td>
                                                            
                                                            
                                                            <input type="text" class="form-control"
                                                                v-model="attachments[index].Description">
                                                        </td>
                                                        <td>
                                                            <span style="color:red;cursor:pointer"
                                                                @click="removeAttachment(index,file)">
                                                                <i class="fa fa-times"></i>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="control-label"
                                                for="StatusID:">{{$t('form.student.fileAttach')}}</label>

                                            <vue-dropzone ref="myVueDropzone" id="dropzone"
                                                :options="attachmentDropzone" @vdropzone-success="attachmentUploaded"
                                                @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true">
                                            </vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        email
    } from "vuelidate/lib/validators";

    export default {
        props: ["permissions",'datetimeFormat'],

        components: {
            vueDropzone: vue2Dropzone,
        },

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                requestSource: '',
                invalidProfessorCountry: false,
                invalidBussinessCountry: false,

                image: `/images/default.jpg`,

                profileDropzone: {
                    url: "/api/professors/profile-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                contractDropzone: {
                    url: "/api/professors/contracts/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                attachmentDropzone: {
                    url: "/api/professors/attachments/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                titles: [],
                departments: [],
                positions: [],
                countries: [],

                courses: [],
                programs: [],

                contracts: [],
                lectures: [],
                attachments: [],

                professor: {
                    FirstName: '',
                    LastName: '',
                    Title: '',
                    BirthDate: null,
                    BirthPlace: '',
                    BirthCountry: '',
                    StreetAddress: '',
                    City: '',
                    Zip: '',
                    Country: '',
                    Phone: '',
                    Mobile: '',
                    Fax: '',
                    Email: '',
                    Email2: '',
                    Email3: '',
                    WebAddress: '',
                    Photo: '',
                    Remarks: '',
                    Notes: '',
                    Department: '',
                    Position: '',
                    MailAddress: 1,
                    SendEmail: null
                },

                professorBusiness: {
                    CompanyName: '',
                    Department: '',
                    Position: '',
                    StreetAddress: '',
                    City: '',
                    Zip: '',
                    Country: '',
                    Phone: '',
                    Mobile: '',
                    Fax: '',
                    Email: '',
                    WebAddress: '',
                    ContactPersonTitle: '',
                    ContactPersonFirstName: '',
                    ContactPersonLastName: '',
                    ContactPersonDepartment: '',
                    Notes: ''
                }
            };
        },

        validations: {
            professor: {
                FirstName: {
                    required,
                    maxLength: maxLength(100)
                },
                LastName: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthPlace: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthDate: {
                    required
                },
                StreetAddress: {
                    required
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                }
            },
            professorBusiness:{
                CompanyName: {
                    required,
                    maxLength: maxLength(100)
                },
                Department: {
                    required,
                    maxLength: maxLength(100)
                },
                Position: {
                    required,
                    maxLength: maxLength(100)
                },
                StreetAddress: {
                    required,
                    maxLength: maxLength(255)
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                },
                ContactPersonFirstName: {
                    maxLength: maxLength(100)
                },
                ContactPersonLastName: {
                    maxLength: maxLength(100)
                },
                ContactPersonDepartment: {
                    maxLength: maxLength(100)
                }
            }

        },

        mounted() {
            if (!this.permissions.createEmployeeProfessors) {
                this.$router.push("/");
                return;
            }

            this.getInitialData();
        },

        computed: {
            academicYearList() {
                let year = moment().format('YYYY');
                let yearlist = [];
                for (let i = 0; i < 18; i++, year--) {
                    yearlist[i] = year;
                }
                return yearlist;
            }
        },

        methods: {

            async createToken(type = null) {
                let response = await axios.post('/api/api-tokens', {
                    type: `professor-${type}`,
                });
                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },

            async downloadAttachment(file , isDownload = false) {

                let token = await this.createToken('attachment');
                if (token == '') return;
                window.open(`/professors/attachments/${file.ID}?file=${file.File}&download=${isDownload}&token=${token}`, '_blank');
            },

            async downloadContract(file , isDownload = false) {

                let token = await this.createToken('contract');
                if (token == '') return;
                window.open(`/professors/contracts/${file.ID}?file=${file.File}&download=${isDownload}&token=${token}`, '_blank');

            },

            getInitialData() {
                axios
                    .get("/api/professors/initial-data")
                    .then(response => {

                        this.titles = response.data.titles;
                        this.countries = response.data.countries;

                        this.departments = response.data.departments;
                        this.positions = response.data.positions;

                        this.programs = response.data.programs;
                        this.programs.map(p => p.FullTitle = this.$options.filters.program(p));
                    })
                    .catch(error => {
                        console.log('error');
                    });
            },


             // show selecete image
            showSelectedImage(){

                 let input = this.$refs.profile_image
                let file = input.files
                if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(file[0])
                this.$emit('input', file[0])
                }

                let fd = new FormData();
                fd.append('file',file[0]);
                this.isLoading = true;
                axios.post('/api/professors/profile-image',fd).then(resp=>{
                    this.professor.Photo = resp.data.filename;
                    this.isLoading = false;
                }).catch(error=>{
                    this.isLoading = false;
                    console.log('file not found');
                });
            },

            contractUploaded(file, response) {
                this.isLoading = false;
                this.contracts.push({
                    Name: response.filename,
                    File: `${response.id}/${response.filename}`,
                    Description: '',
                    AttachmentDate: moment().format('YYYY-MM-DD'),
                    UploadTimestamp: calculateTimeAsPerTimeZone('+2'),
                });
            },

            removeContract(index, attach) {
                let vm = this;
                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/professors/contracts/remove", attach)
                        .then(resp => {
                            this.showAlert(response.data.message)
                            vm.contracts.splice(index, 1);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },

            /**
             * Upload file error on dropzone
             */
            uploadFileError(file, message) {
                this.showAlert(message.errors, 'danger');
                this.isLoading = false;
            },

            /**
             * Add attachment to student attachment list
             */
            attachmentUploaded(file, response) {
                this.isLoading = false;

                this.attachments.push({
                    Name: response.filename,
                    File: `${response.id}/${response.filename}`,
                    Description: '',
                    AttachmentDate: moment().format('YYYY-MM-DD'),
                    UploadTimestamp: calculateTimeAsPerTimeZone('+2'),
                });
            },

            /**
             * Remove attachmemnt from student attachment list
             */
            removeAttachment(index, attach) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/professors/attachments/remove", attach)
                        .then(response => {

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'warning');
                            } else if (response.data.success) {
                                vm.attachments.splice(index, 1);
                                this.showAlert(response.data.message);
                            }

                        })
                        .catch(error => {
                            console.log('error');
                        });
                }
            },

            selectProgram(index) {
                if (!this.lectures[index].ProgramID) return;

                this.getProgramCourses(index);
            },

            /**
             * Get Program Related Courses
             */
            getProgramCourses(index) {
                if (index == null) return;

                this.isLoading = true;

                axios
                    .get(`/api/programs/${this.lectures[index].ProgramID}/courses`)
                    .then(response => {
                        this.isLoading = false;

                        this.courses[index] = response.data;
                        this.courses[index].map(c => c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`);
                    })
                    .catch(error => {
                        this.isLoading = true;
                        console.log('error fetching program related courses')
                    });
            },

            addLecture() {
                this.lectures.push({
                    CourseID: '',
                    ProgramID: '',
                    AcademicYear: '',
                    Term: ''
                });
            },

            removeLecture(index) {
                this.lectures.splice(index, 1);
                this.courses.splice(index, 1);
            },

            saveProfessor() {

                if(parseInt(this.professor.MailAddress) === 2)
                {
                    this.$v.$touch();
                }
                else
                    this.$v.professor.$touch();



                this.invalidProfessorCountry = this.professor.Country == null ? true : false;
                this.invalidBussinessCountry = this.professorBusiness.Country == null ? true : false;


                if (this.$v.professor.$invalid)
                {
                    
                    let errorMsg = '';

                    if(this.$v.professor.FirstName.$error){
                            errorMsg = this.$t('form.employee.firstName');
                      }

                     if(this.$v.professor.LastName.$error){
                            errorMsg =  errorMsg ? errorMsg+', '+this.$t('form.employee.lastName'): this.$t('form.employee.lastName');
                      }

                    if(this.$v.professor.BirthPlace.$error){
                            errorMsg = errorMsg? errorMsg+', '+ this.$t('form.employee.birthPlace'): this.$t('form.employee.birthPlace');
                      }

                    if(this.$v.professor.BirthDate.$error){
                           errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthDate'): this.$t('form.employee.birthDate');
                      }

                    if(this.$v.professor.StreetAddress.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                      }

                        
                        if(this.$v.professor.City.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                      }

                        if(this.$v.professor.Country.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                      }

                       if(this.$v.professor.Zip.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                      }

                    if(this.$v.professor.Mobile.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                      }

                    if(this.$v.professor.Phone.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                      }

                    if(this.$v.professor.Email.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                      }


                    if(this.$v.professorBusiness.CompanyName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.companyName'): this.$t('form.employee.companyName');
                    }

                    if(this.$v.professorBusiness.Department.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.department'): this.$t('form.employee.department');
                    }

                    if(this.$v.professorBusiness.Position.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.position'): this.$t('form.employee.position');
                    }

                     if(this.$v.professorBusiness.StreetAddress.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                    }

                    if(this.$v.professorBusiness.City.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                    }

                    if(this.$v.professorBusiness.Country.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                    }

                     if(this.$v.professorBusiness.Zip.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                    }
                
                    if(this.$v.professorBusiness.Phone.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                    }

                     if(this.$v.professorBusiness.Mobile.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                    }
              
                  if(this.$v.professorBusiness.Email.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                    }
                    if(this.$v.professorBusiness.ContactPersonFirstName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonFirstName'): this.$t('form.employee.contactPersonFirstName');
                    }
              
                     if(this.$v.professorBusiness.ContactPersonLastName.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonLastName'): this.$t('form.employee.contactPersonLastName');
                    }
               
                     if(this.$v.professorBusiness.ContactPersonDepartment.$error){
                         errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.contactPersonDepartment'): this.$t('form.employee.contactPersonDepartment');
                    }
               
                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                if(parseInt(this.professor.MailAddress) === 2)
                if (this.$v.$invalid)
                {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }


                let formData = new FormData();

                formData.append('professor', JSON.stringify(this.professor));
                formData.append('bussiness', JSON.stringify(this.professorBusiness));

                this.lectures.forEach(lecture => formData.append("lectures[]", JSON.stringify(lecture)));
                this.contracts.forEach(contract => {
                    
                    
                    contract.UploadTimestamp = contract.UploadTimestamp ? contract.UploadTimestamp : null
                    formData.append("contracts[]", JSON.stringify(contract));
                    
                });
                this.attachments.forEach(attach => 
                {

                    attach.UploadTimestamp = attach.UploadTimestamp ? attach.UploadTimestamp : null
                    formData.append("attachments[]", JSON.stringify(attach));
                
                });

                this.isLoading = true;

                axios
                    .post("/api/professors", formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.message) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'ProfessorIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error saving professor record.');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
    .searchBackground:hover {
        background: #cececf;
    }

    #dropzone {
        padding: 0;
        margin: 0;
    }

    .custom-validate {
        display: block !important;
    }

    .v-select ul.vs__dropdown-menu {
        margin: 0 !important;
    }

    .professor .v-select ul.vs__dropdown-menu {
        position: relative !important;
    }

    .v-select {
        background: #fff;
    }

</style>
